/**
 * @desc 审批单详情
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(approvalNo: string | number, options?: any) {
  return updateResponse(
    http(URL + `/wms/AllolcationTrial/getrDetail/${approvalNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
